import { createContext } from 'react'

const OptionsContext = createContext({
  options: {},
  setOptions: () => {},
  toggleThemeSound: () => {},
  playSoundEffect: () => {},
  hasVoiceover: false,
  playVoiceover: () => {},
  isMobile: false,
  setShouldShowAlertBox: () => {},
  shouldShowAlertBox: true,
})

export default OptionsContext
